import useCrud from 'hooks/useCrud';
import { list } from 'services/api/store';

function useStore() {
  return useCrud({
    readList: list,
  });
}

export default useStore;
